import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

import {
  loadBackOfficeDeviceCameraSamplePoints,
  loadBackOfficeDevices
} from 'store/modules/backOfficeDevices/actions';

import { useBackOfficeDevicesRequestParameters } from '../useBackOfficeRequestParameters';

function BackOfficeDevicesRequest(): null {
  const parameters = useBackOfficeDevicesRequestParameters();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadBackOfficeDeviceCameraSamplePoints());
  }, [dispatch]);

  useDeepCompareEffect(() => {
    dispatch(loadBackOfficeDevices(parameters));
  }, [dispatch, parameters]);

  return null;
}

export default memo(BackOfficeDevicesRequest);
